import { render, staticRenderFns } from "./EmisionDetalle.vue?vue&type=template&id=f9c30bee&scoped=true"
import script from "./EmisionDetalle.vue?vue&type=script&lang=js"
export * from "./EmisionDetalle.vue?vue&type=script&lang=js"
import style0 from "./EmisionDetalle.vue?vue&type=style&index=0&id=f9c30bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c30bee",
  null
  
)

export default component.exports